// Toast notification provider - manages global notifications
import React, { createContext, useCallback, useContext, useState } from "react";
import { uid } from "../lib/utils/id";
import { cn } from "../lib/utils/cn";

const ToastCtx = createContext({ notify: /** @param {{type:"success"|"error"|"info", message:string, duration?:number}} _e */ (_e)=>{} });

export function ToastProvider({ children }){
  // Toast state management
  const [toasts, setToasts] = useState([]);
  
  // Function to show notifications
  const notify = useCallback(({ type, message, duration = 3500 }) => {
    const id = uid();
    setToasts((t) => [...t, { id, type, message }]);
    setTimeout(() => setToasts((t) => t.filter((x) => x.id !== id)), duration);
  }, []);
  return (
    <ToastCtx.Provider value={{ notify }}>
      {children}
      <div className="fixed top-4 right-4 space-y-2 z-[9999]">
        {toasts.map((t) => (
          <div key={t.id} className={cn(
            "min-w-[260px] rounded-2xl shadow-lg px-4 py-3 text-sm",
            t.type === "success" && "bg-green-600 text-white",
            t.type === "error" && "bg-red-600 text-white",
            t.type === "info" && "bg-slate-800 text-white"
          )}>{t.message}</div>
        ))}
      </div>
    </ToastCtx.Provider>
  );
}
export const useToast = () => useContext(ToastCtx);